import { useCallback, useMemo } from 'react';
import { SessionSetting } from '../constants/ui';

type SessionSettings = {
  [SessionSetting.SidenavExpanded]: boolean | null;
};

const parseBoolean = (value: string | null): boolean | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (value === 'true') return true;
  if (value === 'false') return false;

  return null;
};

const getSessionValue = (key: SessionSetting): boolean | null => {
  try {
    const value = sessionStorage.getItem(key);
    return parseBoolean(value);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Error reading from sessionStorage for key: ${key}`, error);
    return null;
  }
};

const setSessionValue = (key: SessionSetting, value: boolean): void => {
  try {
    sessionStorage.setItem(key, String(value));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Error writing to sessionStorage for key: ${key}`, error);
  }
};

export const useSessionSettings = () => {
  const sessionSettings: SessionSettings = useMemo(() => ({
    [SessionSetting.SidenavExpanded]: getSessionValue(SessionSetting.SidenavExpanded),
  }), []);

  const updateSessionSetting = useCallback((key: SessionSetting, value: boolean) => {
    setSessionValue(key, value);
  }, []);

  return {
    sessionSettings,
    updateSessionSetting,
  };
};
